import React from 'react';

const PrivacyPage: React.FC = () => {
  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16">
      <h1 className="text-3xl md:text-4xl font-serif font-bold text-navy-900 mb-6">
        Privacy Policy
      </h1>
      <div className="prose prose-lg max-w-none">
        <p className="text-gray-700 leading-relaxed mb-4">
          This privacy policy page is currently being prepared. Please contact us at{' '}
          <a href="mailto:quirketrophies@mail.com" className="text-gold-600 hover:text-gold-700 underline">
            quirketrophies@mail.com
          </a>{' '}
          or call (052) 743 0288 if you have any questions about how we handle your personal information.
        </p>
        <p className="text-gray-700 leading-relaxed">
          We are committed to protecting your privacy and ensuring the security of your personal data.
        </p>
      </div>
    </div>
  );
};

export default PrivacyPage;

